// @flow
import React, { Node, useEffect, useState } from "react";
import { Collapse } from "react-collapse";
import bem from "@justpark/helpers/src/bem/bem";

import "./collapsibleContainer.scss";

type Props = {
  isOpened: boolean,
  children: Node
};

const CollapsibleContainer = ({ isOpened, children }: Props) => {
  const animationDuration = 300;
  const [lockOpen, setLockOpen] = useState(false);
  const [open, setOpen] = useState(isOpened);

  useEffect(() => {
    // If open state has changed allow css animation
    setLockOpen(false);
    // Copy the open prop into local state so that it's changed the same render step as the lock
    setOpen(isOpened);

    if (isOpened) {
      const id = setTimeout(() => {
        setLockOpen(true);
      }, animationDuration);

      return () => {
        clearTimeout(id);
      };
    }

    return () => {};
  }, [isOpened, setLockOpen, setOpen]);

  const baseClass = "c-collapsible-container";
  const theme = {
    collapse: bem(baseClass, "collapse", {
      lockOpen
    }),
    content: bem(baseClass, "content")
  };

  return (
    <Collapse isOpened={open} theme={theme}>
      {children}
    </Collapse>
  );
};

CollapsibleContainer.defaultProps = {
  isOpened: false,
  children: null
};

export default CollapsibleContainer;
